export const callToAction = ['立即下载', '极速下载', '点我玩玩', '新手礼包', '查看详情', '立即闯关', '玩家福利', '等你来战', '官方下载', '免费下载']
